import {linkRel} from "./linkRel";

export interface errorDto {
	name:string
	code:number
	method:string
	title:string
	description:string
	requestId:string
	additionalDetails: { [key: string]:string }
	_links: { [key: string]:linkRel}
}

export class ErrorHandler {
	static parseError = (responseText:string):errorDto => {
		return JSON.parse(responseText)
		// try {
		// 	let dto:errorDto = JSON.parse(responseText);
		// } catch(exp) {
		// 	console.error(exp);
		// 	return null;
		// }
	};

	static showErrorDialogByDto = (dto:errorDto, category: string, dux:any) => {
		dux.query.modalizer({
			title: dto.name,
			closeButton: false,
			draggable: false,
			category: category,
			alert: dto.title,
			body: dto.description,
			buttons: {
				'OK': function () {	}
			},
			modal: {
				backdrop: true,
				keyboard: false
			}
		})
	};

	static showErrorDialogByResponse = (dto: errorDto, title: string, alert: string, category: string, dux:any) => {
		dux.query.modalizer({
			title: title,
			closeButton: false,
			draggable: false,
			category: category,
			alert: alert,
			body: dto.description,
			buttons: {
				'OK': function () {	}
			},
			modal: {
				backdrop: true,
				keyboard: false
			}
		})
	};

	static showErrorDialogByOwn = (title: string, alert: string, body: string, category: string, dux: any) => {
		dux.query.modalizer({
			title: title,
			closeButton: false,
			draggable: false,
			category: category,
			alert: alert,
			body: body,
			buttons: {
				'OK': function () {

				}
			},
			modal: {
				backdrop: true,
				keyboard: false
			}
		})
	};
}
